export default __webpack_public_path__ + "static/media/exclamation-mark-white.5143dabb.svg";